module.exports = __webpack_public_path__ + "static/media/opera.635d9409.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/opera.png
// module id = 162
// module chunks = 0